<div class="auth">
  <div class="header">
    <div class="header-icon">
      <img src="../../../../assets/images/Logo.png" alt="" />
    </div>
    <div class="header-lang">
      <div
        class="header-lang__item"
        [ngClass]="lang() === 'en' ? 'active' : ''"
        (click)="changeLang('en')"
      >
        EN
      </div>
      <div
        class="header-lang__item"
        [ngClass]="lang() === 'ru' ? 'active' : ''"
        (click)="changeLang('ru')"
      >
        RU
      </div>
    </div>
  </div>
  <div class="main">
    <img
      alt=""
      src="../../../../assets/images/Logo.png"
      style="width: 164px; margin-bottom: 12px"
    />
    @switch (loginStep()) {
      @case ('login') {
        <div class="main-title">
          {{ "auth.title" | translate }}
        </div>
        <div class="main__login-toggle">
          <div
            class="main__login-toggle-item"
            [ngClass]="loginType() === 0 ? 'active' : ''"
            (click)="changeLoginType(0)"
          >
            {{ "auth.mail" | translate }}
          </div>
          <div
            class="main__login-toggle-item"
            [ngClass]="loginType() === 1 ? 'active' : ''"
            (click)="changeLoginType(1)"
          >
            {{ "global.phone" | translate }}
          </div>
        </div>
        @if (
          (!loginType() && email.errors && email.touched) ||
          (loginType() && phone.errors && phone.touched) ||
          getCodeError ||
          errorMessage
          ) {
          @if (errorMessage) {
            <div class="errorBlock">{{ errorMessage.message }}</div>
          } @else {
            <div class="errorBlock">{{ getErrorMessage() | translate }}</div>
          }
        }
        <mat-form-field class="formInput">
          <mat-select
            [formControl]="selectedCountry"
            [placeholder]="'profilePage.country' | translate"
            (selectionChange)="phone.setValue(''); phone.markAsUntouched()"
          >
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'profilePage.country' | translate"
                [formControl]="countryListFilter"
                [noEntriesFoundLabel]="'global.nothingFound' | translate"
              ></ngx-mat-select-search>
            </mat-option>
            @for (country of countryListFiltered(); track country.country_id) {
              <mat-option [value]="country.country_id">
                {{ country.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (loginType()) {
          <mat-form-field class="formInput">
            <input
              matInput
              name="phone"
              [placeholder]="getCountryPhoneCode()"
              [formControl]="phone"
              type="tel"
              (change)="email.markAsUntouched(); getCodeError = false"
            />
          </mat-form-field>
        } @else {
          <mat-form-field class="formInput email">
            <input
              matInput
              name="mail"
              placeholder="Email"
              [formControl]="email"
              class="emailInput"
              type="email"
              (input)="email.markAsUntouched(); getCodeError = false"
            />
          </mat-form-field>
        }
        <button
          class="btn btn-getCode"
          (click)="getCode()"
          [disabled]="
            (!loginType() && (email.errors || email.value === '')) ||
            (loginType() &&
              (phone.errors || phone.value === getCountryPhoneCode()))
          "
        >
          {{ "auth.getCode" | translate }}
        </button>
        <button
          class="btn btn-enterWithPassword"
          (click)="showLoginWithPassword()"
        >
          {{ "auth.enterWithPassword" | translate }}
        </button>
        <p>{{ "auth.or" | translate }}</p>
        <div class="auth-iconList">
          @if (selectedCountry && getSelectedCountryId() === 1) {
            <a [href]="getSocialLink('vk')">
              <img src="../../../../assets/images/socials/vk-Logo.png" alt="" />
            </a>
            <a [href]="getSocialLink('yandex')">
              <img
                src="../../../../assets/images/socials/yandex-Logo.png"
                alt=""
              />
            </a>
          } @else {
            <a [href]="getSocialLink('google')">
              <svg
                class="NEH9Ef"
                width="20"
                height="24"
                viewBox="0 0 40 48"
                aria-hidden="true"
              >
                <path
                  fill="#4285F4"
                  d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z"
                ></path>
                <path
                  fill="#34A853"
                  d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z"
                ></path>
                <path
                  fill="#FABB05"
                  d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z"
                ></path>
                <path
                  fill="#E94235"
                  d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z"
                ></path>
              </svg>
            </a>
          }
          <!--          <img-->
          <!--            src="../../../../assets/images/socials/Gosuslugi-Logo.png"-->
          <!--            alt=""-->
          <!--          />-->
          <!--          <img src="../../../../assets/images/socials/MailRu-Logo.png" alt="" />-->
        </div>
      }
      @case ('withPassword') {
        <app-login-with-password
          style="width: 100%"
          (showConfirm)="showConfirmationFromPassword($event)"
          [newPassword]="newPassword"
        ></app-login-with-password>
      }
      @case ('confirmation') {
        <app-confirmation
          [loginType]="loginType()"
          [payload]="loginType() === 1 ? (phone.value || '') : (email.value || '')"
          (setNewPassword)="routeToCreatePassword()"
          (showNewTelPage)="routeToNewTel()"
          [country_id]="getSelectedCountryId()!"
          style="width: 100%"
        >
        </app-confirmation>
      }
      @case ('newTel') {
        <app-newtel [tel]="phone.value" (showNewPassword)="routeToCreatePassword()"></app-newtel>
      }
    }
    @if (showBackBtn()) {
      <button class="back" (click)="showConfirmation(false)">
        <img src="../../../../assets/icons/icon-arrow-left-grey.svg" alt="" />
      </button>
    }
    <div class="footer">
      <p>
        {{ "auth.footer.text1" | translate }}
        <a
          href="https://{{
            $t.getDefaultLang() === 'ru' ? 'ru.' : ''
          }}qform.io/service-offer"
          target="_blank"
          >{{ "auth.footer.text2" | translate }} </a
        ><a
          href="https://{{
            $t.getDefaultLang() === 'ru' ? 'ru.' : ''
          }}qform.io/policy"
          target="_blank"
          >{{ "auth.footer.text3" | translate }}</a
        >
        {{ "auth.footer.text4" | translate }}
        <a
          href="https://{{
            $t.getDefaultLang() === 'ru' ? 'ru.' : ''
          }}qform.io/license"
          target="_blank"
          >{{ "auth.footer.text5" | translate }}</a
        >
      </p>
    </div>
  </div>
</div>
